import { Button } from '@nf/ui';
import { coinsStyles } from '@/features/saba-coins/saba-coins-toggle/saba-coins-toggle.style';
import { DetailsIcon } from '@/components/icons/svg-icons';
import { Modal } from '@/components/widgets/modal';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';

export const RnrButton = () => {
	const t = useTranslations('General');
	const [showingRnr, setShowingRnr] = useState<boolean>(false);

	const handleRnrClick = () => {
		const kafkaData = {
			note: KafkaNote.Reward,
			type: 7,
			action: 3 
		}
		!showingRnr && setKafkaNormal(kafkaData);	
		setShowingRnr(!showingRnr);
	}
	
	return (
		<Button
			variant="icon"
			className={coinsStyles.btnIcon}
			onClick={handleRnrClick}
		>
			<DetailsIcon />
			<Modal
				variant="top"
				isOpen={showingRnr}
				closeModal={() => setShowingRnr(!showingRnr)}
				title={t('lbl_SBCRRTittle')}
				isBackdropClose={true}
			>
				<section className="rules-modal scrollbar">
					<div className="rules-modal__title">{t('lbl_SBCRR')}</div>
					<ul>
						<li>{t('lbl_SBCRR01')}</li>
						<li>{t('lbl_SBCRR02')}</li>
						<li>{t('lbl_SBCRR03')}</li>
						<li>{t('lbl_SBCRR04')}</li>
						<li>{t('lbl_SBCRR06')}</li>
						<li>{t('lbl_SBCRR07')}</li>
						<li>{t('lbl_SBCRR08')}</li>
						<li>{t('lbl_SBCRR09')}</li>
					</ul>
				</section>
			</Modal>
		</Button>
	);
};